module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f5114d2193b76184f5aa2f80b063f232.png";